import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXXL, space3XL } from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const Container = styled.section`
  margin-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    margin-bottom: ${space3XL};
  }
`;

export const Title = styled(Headline)`
  margin-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    margin-bottom: ${space3XL};
  }
`;

export const Text = styled(BodyCopy)`
  margin-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    margin-bottom: ${space3XL};
  }
`;
